/**
 * @generated SignedSource<<7575f5dad4744581e00284b61134ba81>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type BlogPostStatusEnum = "approved" | "draft" | "published";
import { FragmentRefs } from "relay-runtime";
export type BlogPost_BlogPostFragment$data = {
  readonly content: string | null | undefined;
  readonly excerpt: string | null | undefined;
  readonly id: string;
  readonly status: BlogPostStatusEnum | null | undefined;
  readonly title: string | null | undefined;
  readonly updatedAt: string | null | undefined;
  readonly user: {
    readonly avatarUrl: string | null | undefined;
    readonly name: string | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPostLanding_BlogPost" | "BlogPostSignedIn_BlogPost">;
  readonly " $fragmentType": "BlogPost_BlogPostFragment";
};
export type BlogPost_BlogPostFragment$key = {
  readonly " $data"?: BlogPost_BlogPostFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"BlogPost_BlogPostFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BlogPost_BlogPostFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "excerpt",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "content",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "avatarUrl",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "updatedAt",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlogPostLanding_BlogPost"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BlogPostSignedIn_BlogPost"
    }
  ],
  "type": "BlogPost",
  "abstractKey": null
};

(node as any).hash = "dc77babed6321d6da6b72ed497c62256";

export default node;
